import React from 'react';

export const LoadingComponent = ({ text = 'Loading...' }) => {
    return (
        <div className="loading-component d-flex flex-column align-items-center justify-content-center">
            <div
                className="spinner-border text-primary mb-3"
                style={{ width: '5rem', height: '5rem' }}>
                <span className="visually-hidden">{text}</span>
            </div>
            <p className="text-muted">{text}</p>
        </div>
    );
};
